export interface CalendarCell {
  date: Date;
  iso: string;
  day: number;
  inMonth: boolean;
  isToday: boolean;
  isSelected: boolean;
}

export const CALENDAR_CELL_COUNT = 42;
export const WEEK_LENGTH = 7;
